import { render, staticRenderFns } from "./ProcDefList.vue?vue&type=template&id=65149419&"
import script from "./ProcDefList.vue?vue&type=script&lang=js&"
export * from "./ProcDefList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports